"use client";

import { RotateCw } from "lucide-react";

// Shown when the page is from an older deploy (see lib/stale-deploy.ts) — a
// full reload is the only thing that fixes it. Used by every app.
export function ReloadAppButton({ className = "mt-2" }: { className?: string }) {
  return (
    <button
      type="button"
      data-bc="Reload after app update"
      onClick={() => window.location.reload()}
      className={`${className} flex h-[34px] items-center gap-1.5 rounded-[var(--radius-sm)] px-3 text-[13px] font-extrabold text-white transition active:scale-[0.98]`}
      style={{ backgroundColor: "hsl(var(--accent))" }}
    >
      <RotateCw className="size-[15px]" strokeWidth={2.4} aria-hidden />
      Reload
    </button>
  );
}
